export default __webpack_public_path__ + "static/media/notification_simple-01.052c2644.mp3";